export default "__VITE_ASSET__Cgl7LsdD__"